module.exports = __webpack_public_path__ + "static/media/04.150a2bfe.jpg";